module.exports = __webpack_public_path__ + "static/videoPR_1-91983012e6d92a5aa5a23f018ec3af8b.mp4";